module.exports = __webpack_public_path__ + "static/media/purchase-succeeded.6b19312c.png";